import { createStore, applyMiddleware } from "redux";
import createSocketIoMiddleware from "redux-socket.io";
import io from "socket.io-client";

// let socket = io(process.env.API_URL);
let socket = io("https://decksocket-dot-coderschool-users.an.r.appspot.com");
// let socket = io("http://34.87.51.47:3000/");
let socketIoMiddleware = createSocketIoMiddleware(socket, "server/");

const DEVELOPMENT = true;

function reducer(
  state = {
    livePresenter: false,
    follow: true,
    verified: false,
    count: 0,
    polls: [],
    html: "",
    css: "",
    js: "",
    width: 500,
    height: 600,
    lastUpdated: 0,
    subtitles: "",
  },
  action
) {
  switch (action.type) {
    case "userCount":
      return Object.assign({}, { ...state, count: action.data });
    case "pollUpdate":
      return Object.assign({}, { ...state, polls: action.data });
    case "follow":
      return Object.assign({}, { ...state, follow: action.data });
    case "verify":
      return Object.assign({}, { ...state, verified: action.data });
    case "updatePresIndex":
      return Object.assign({}, { ...state, presentation: action.data });
    case "startLivePresentor":
      return Object.assign(
        {},
        { ...state, livePresenter: true, presentation: action.data }
      );
    case "endLivePresentor":
      return Object.assign(
        {},
        {
          ...state,
          livePresenter: false,
          presentation: undefined,
          verified: false,
        }
      );
    case "updateCodeEditorPreviewSize":
      return Object.assign(
        {},
        {
          ...state,
          width: action.data.width,
          height: action.data.height,
        }
      );
    case "updateSubtitles":
      return Object.assign(
        {},
        {
          ...state,
          subtitles: action.data,
        }
      );
    case "updateCodeEditor":
      // ignore old keystrokes coming in out of order
      if (action.data.timestamp < state.lastUpdated) {
        console.log("IGNORED");
        return state;
      }
      return Object.assign(
        {},
        {
          ...state,
          [action.data.codeType]: action.data.code,
          lastUpdated: action.data.timestamp,
        }
      );
    default:
      return state;
  }
}
let store = applyMiddleware(socketIoMiddleware)(createStore)(reducer);
store.subscribe(() => {
  if (DEVELOPMENT) {
    console.log("new client state", store.getState());
  }
});

export default store;
